import { Menu, MenuButtonProps, Text } from '@televet/kibble-ui';
import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import React from 'react';
import { FiltersOverview } from './FiltersOverview';
import { useFilter } from './hooks/useFilter';
import { FilterBaseOption, FilterOptionGroup } from './types';

type FilterProps = {
  label: string;
  selectedOptions: FilterBaseOption[];
  showSearchBar?: boolean;
  showSelectAllOption?: boolean;
  optionGroups?: FilterOptionGroup[];
  options?: FilterBaseOption[];
  isReadOnly?: boolean;
  isLastRow?: boolean;
  onValueChange: (options: FilterBaseOption[]) => void;
  filterContainerWidth?: string | number;
  renderOption?: (option: FilterBaseOption) => JSX.Element;
  isGrouped?: boolean;
  buttonTestId?: string;
};

export const Filter = ({
  label,
  selectedOptions,
  showSearchBar,
  showSelectAllOption,
  optionGroups,
  options,
  isReadOnly,
  isLastRow,
  onValueChange,
  filterContainerWidth,
  isGrouped,
  renderOption,
  buttonTestId,
}: FilterProps): JSX.Element => {
  const { filteredOptions, handleToggleOption } = useFilter({
    optionGroups,
    options,
    selectedOptions,
    onValueChange,
    isGrouped,
    renderOption,
  });

  return (
    <Box borderBottom="1px" borderBottomColor={isLastRow ? 'transparent' : 'border.default'}>
      <Flex flexDirection="column" py={3} px={4}>
        <Flex alignItems="center" gap={1.5}>
          <Text fontWeight="bold" size="sm">
            {label}:
          </Text>
          <Menu
            id="filter-menu"
            buttonProps={
              {
                variant: 'tertiary',
                leftIconName: 'plus',
                size: 'xs',
                showRightIcon: false,
                'data-testid': buttonTestId,
              } as MenuButtonProps // Explicit conversion needed for data-testid
            }
            listProps={{
              canSelectAll: showSelectAllOption,
              canSelectGroups: false,
              isMultiSelect: true,
              isSearchable: showSearchBar,
              menuItems: filteredOptions,
              isGrouped,
              minWidth: filterContainerWidth,
              width: filterContainerWidth,
              maxWidth: filterContainerWidth,
            }}
          />
        </Flex>
        <Flex mt={1} gap={1} flexWrap="wrap" width="300px">
          <FiltersOverview
            selectedOptions={selectedOptions}
            isReadOnly={isReadOnly}
            handleToggleOption={handleToggleOption}
          />
        </Flex>
      </Flex>
    </Box>
  );
};
